import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["color"],
  _excluded2 = ["color"],
  _excluded3 = ["color"],
  _excluded4 = ["color"];
import React, { memo } from 'react';
export const SmallIcon = /*#__PURE__*/memo(_ref => {
  let {
      color = '#7d8a96'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "49",
    fill: "none",
    viewBox: "0 0 48 49"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M16.93 14.5h14.14c1.614.006 2.924 1.316 2.93 2.93v14.14c-.006 1.614-1.316 2.924-2.93 2.93H16.93c-1.614-.006-2.924-1.316-2.93-2.93V17.43c.006-1.614 1.316-2.924 2.93-2.93zm14.08 2.99v14.02H16.99V17.49h14.02z",
    clipRule: "evenodd"
  }));
});
export const VerticalIcon = /*#__PURE__*/memo(_ref2 => {
  let {
      color = '#7d8a96'
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "49",
    fill: "none",
    viewBox: "0 0 48 49"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M34 9.43v30.14c-.006 1.614-1.316 2.924-2.93 2.93H16.93c-1.614-.006-2.924-1.316-2.93-2.93V9.43c.006-1.614 1.316-2.924 2.93-2.93h14.14c1.614.006 2.924 1.316 2.93 2.93zm-2.99 30.08H16.99V9.49h14.02v30.02z",
    clipRule: "evenodd"
  }));
});
export const HorizontalIcon = /*#__PURE__*/memo(_ref3 => {
  let {
      color = '#7d8a96'
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "49",
    fill: "none",
    viewBox: "0 0 48 49"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M9.43 14.5h30.14c1.614.006 2.924 1.316 2.93 2.93v14.14c-.006 1.614-1.316 2.924-2.93 2.93H9.43c-1.614-.006-2.924-1.316-2.93-2.93V17.43c.006-1.614 1.316-2.924 2.93-2.93zm30.08 2.99v14.02H9.49V17.49h30.02z",
    clipRule: "evenodd"
  }));
});
export const BigIcon = /*#__PURE__*/memo(_ref4 => {
  let {
      color = '#7d8a96'
    } = _ref4,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "49",
    fill: "none",
    viewBox: "0 0 48 49"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M8.93 6.5h30.14c1.614.006 2.924 1.316 2.93 2.93v30.14c-.006 1.614-1.316 2.924-2.93 2.93H8.93c-1.614-.006-2.924-1.316-2.93-2.93V9.43c.006-1.614 1.316-2.924 2.93-2.93zm30.08 2.99v30.02H8.99V9.49h30.02z",
    clipRule: "evenodd"
  }));
});